var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('OrderDetailStudio7',{attrs:{"is-staff-guarantee-payment":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }